import {me, isMe}         from "./me";
import {isUnauthorized}   from "./isUnauthorized";
import {isAuthorized}     from "./isAuthorized";
import {
	isActive,
	isNotActive
}                         from "./isActive";
import {
	isAdmin,
	canManageUsers,
	hasPermission
}						  from "./isAdmin";
import {
    relationFilter
}                         from "./relations";

import {
	countryTemplate, countriesTemplate
}  from "./countries";
import {requestStatus} from "./requestStatus";
import {urlParse, getObjectId, getObjectByUrl, getObjectByKey, getObjectByKeyValue} from "./urlParse";
import {defaultDateFormatDays, datesDiffInDays} from "./date.filters";
export const FiltersModule = angular
	.module("filters", [])
	.filter("me", me)
	.filter("isMe", isMe)
	.filter("isUnauthorized", isUnauthorized)
	.filter("isAuthorized", isAuthorized)
	.filter("isActive", isActive)
	.filter("isNotActive", isNotActive)
	.filter("isAdmin", isAdmin)
	.filter("canManageUsers", canManageUsers)
	.filter("hasPermission", hasPermission)
	.filter("countryTemplate", countryTemplate)
	.filter("countriesTemplate", countriesTemplate)
	.filter("requestStatus", requestStatus)
    .filter("relation", relationFilter)
	.filter("urlParse", urlParse)
	.filter("getObjectId", getObjectId)
	.filter("getObjectByUrl", getObjectByUrl)
	.filter("getObjectByKey", getObjectByKey)
	.filter("getObjectByKeyValue", getObjectByKeyValue)
	.filter("defaultDateFormatDays", defaultDateFormatDays)
	.filter("datesDiffInDays", datesDiffInDays);


// WEBPACK FOOTER //
// ./sources/filters/filters.js